const videos = [
  youtube("Hola", "2019-04-02", "UEAF3M0U29I", "Palabras aqui"),
  youtube(
    "Mikhail Tal",
    "2019-04-01",
    "S8SK2g3fJjc",
    "Quisque id tortor eget augue tempor tincidunt at sit amet ipsum."
  ),
  youtube(
    "Bobby Fischer",
    "2019-04-01",
    "QHydkEARVKE",
    "Nam id quam vitae risus hendrerit ullamcorper vitae non nunc. Vestibulum maximus elit ut libero tempus, vitae rutrum nunc consequat."
  )
];

const audios = [
  soundcloud(
    "Metric",
    "2019-04-01",
    "https://soundcloud.com/metric-band/breathing-underwater-mahogany",
    "Nulla varius neque sed laoreet euismod. Sed tincidunt mauris condimentum sapien eleifend aliquet."
  ),
  soundcloud(
    "Celebrate",
    "2019-04-01",
    "https://soundcloud.com/metric-band/celebrate",
    "Vestibulum dignissim nisi mauris, a finibus mi pulvinar nec."
  )
];

function youtube(title, date, videoId, description) {
  return {
    type: "video",
    source: "youtube",
    title,
    date,
    videoId,
    description
  };
}

function soundcloud(title, date, url, description) {
  return {
    type: "audio",
    source: "soundcloud",
    title,
    date,
    url,
    description
  };
}

export { videos, audios };
